module.exports = __webpack_public_path__ + "media/lobby_normal5.cfab449f.mp3";